import axios from "axios";

var admin_api = {
  async fetch_all_accounts(active_only = true) {
    let accounts = [];
    let params = {
      limit: 100,
    };
    let has_more = true;
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/account?active_only=${active_only}`;
    while (has_more) {
      await axios
        .get(request_url, { params })
        .then((response) => {
          accounts = accounts.concat(response.data.data);
          params["starting_after"] = response.data.data.at(-1).account_id;
          has_more = response.data.has_more;
        })
        .catch(() => {
          has_more = false;
        });
    }
    return accounts;
  },

  async fetch_all_users(account_id, active_only = true) {
    let request_url = "";
    let users = [];
    let params = {
      limit: 100,
    };
    let has_more = true;
    if (account_id) {
      request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/account/${account_id}/user?active_only=${active_only}`;
    } else {
      request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/users?active_only=${active_only}`;
    }
    while (has_more) {
      await axios
        .get(request_url, { params })
        .then((response) => {
          users = users.concat(response.data.data);
          has_more = response.data.has_more;
          if (account_id) {
            params["starting_after"] = response.data.data.at(-1).user_id;
          } else {
            params["starting_after"] = `${
              response.data.data.at(-1).account_id
            }:${response.data.data.at(-1).user_id}`;
          }
        })
        .catch(() => {
          has_more = false;
        });
    }
    return users;
  },

  async fetch_all_named_selects(account_id) {
    let selects = [];
    let params = {
      limit: 100,
    };
    let has_more = true;

    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/metadata/query/account/${account_id}`;

    while (has_more) {
      await axios
        .get(request_url, { params })
        .then((response) => {
          selects = selects.concat(response.data.data);
          has_more = response.data.has_more;
          params["starting_after"] = response.data.data.at(-1).query_id;
        })
        .catch(() => {
          has_more = false;
        });
    }
    return selects;
  },

  async get_account(account_id) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/account/${account_id}`;
    const response = await axios.get(request_url);
    return response;
  },

  async get_user(account_id, user_id) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/account/${account_id}/user/${user_id}`;
    const response = await axios.get(request_url);
    return response;
  },

  async get_account_listing_page(page_id, active_only, api_filters) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/account?starting_after=${page_id}&active_only=${active_only}${api_filters}`;
    const response = await axios.get(request_url, { retry: 1 });
    return response;
  },

  async get_user_listing_page(account_id, page_id, active_only, api_filters) {
    let request_url = "";
    if (account_id) {
      request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/account/${account_id}/user?starting_after=${page_id}&active_only=${active_only}${api_filters}`;
    } else {
      request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/users?starting_after=${page_id}&active_only=${active_only}${api_filters}`;
    }
    const response = await axios.get(request_url, { retry: 1 });
    return response;
  },

  async get_order_listing_page(
    account_id,
    page_id,
    start_date,
    end_date,
    sort,
    api_filters
  ) {
    let request_url = "";
    if (account_id) {
      request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/account/${account_id}/order?starting_after=${page_id}&start_date=${start_date}&end_date=${end_date}&sort=${sort}${api_filters}`;
    } else {
      request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/order?starting_after=${page_id}&start_date=${start_date}&end_date=${end_date}&sort=${sort}${api_filters}`;
    }
    const response = await axios.get(request_url, { retry: 1 });
    return response;
  },

  async get_select_listing_page(
    account_id,
    page_id,
    start_date,
    end_date,
    sort,
    named_only,
    api_filters
  ) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/metadata/query/account/${account_id}?starting_after=${page_id}&start_date=${start_date}&end_date=${end_date}&sort=${sort}&named_only=${named_only}${api_filters}`;
    const response = await axios.get(request_url, { retry: 1 });
    return response;
  },

  async post_account(account) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/account`;
    const response = await axios.post(request_url, account);
    return response;
  },

  async post_user(account_id, user) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/account/${account_id}/user`;
    const response = await axios.post(request_url, user);
    return response;
  },

  async resend_verification(account_id, user_id) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/account/${account_id}/user/${user_id}/resend_verification`;
    const response = await axios.post(request_url);
    return response;
  },

  async patch_account(account_id, account) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/account/${account_id}`;
    const response = await axios.patch(request_url, account);
    return response;
  },

  async patch_user(account_id, user_id, user) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/account/${account_id}/user/${user_id}`;
    const response = await axios.patch(request_url, user);
    return response;
  },

  async disable_account(account_id) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/account/${account_id}`;
    const response = await axios.delete(request_url);
    return response;
  },

  async disable_user(account_id, user_id) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/account/${account_id}/user/${user_id}`;
    const response = await axios.delete(request_url);
    return response;
  },

  async get_creds_listing_page(account_id, page_id, api_filters) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/account/${account_id}/credentials?starting_after=${page_id}${api_filters}`;

    const response = await axios.get(request_url);
    return response;
  },

  async get_credentials(account_id, creds_id) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/account/${account_id}/credentials/${creds_id}`;
    const response = await axios.get(request_url);
    return response;
  },

  async put_credentials(account_id, creds_id, credentials) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/account/${account_id}/credentials/${creds_id}`;
    const response = await axios.put(request_url, credentials);
    return response;
  },

  async patch_credentials(account_id, creds_id, credentials) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/account/${account_id}/credentials/${creds_id}`;
    const response = await axios.patch(request_url, credentials);
    return response;
  },

  async delete_credentials(account_id, creds_id) {
    const request_url = `https://${process.env.VUE_APP_ARD_DOMAIN}/admin/account/${account_id}/credentials/${creds_id}`;
    const response = await axios.delete(request_url);
    return response;
  },
};

export default admin_api;
